// extracted by mini-css-extract-plugin
export default {"switchRoot":"CustomSwitch_switchRoot__1NWaN","labelLeft":"CustomSwitch_labelLeft__FMsPW","labelRight":"CustomSwitch_labelRight__hl-Pm"};